import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade edit-profile",
  id: "t2o_profile_form_modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header justify-content-space-between" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Upload Picture"),
  /*#__PURE__*/_createElementVNode("a", {
    type: "button",
    class: "close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "×")
    ])
  ])
], -1)
const _hoisted_5 = { class: "modal-body d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_6 = { class: "d-flex flex-column me-n7 pe-7" }
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "fv-row" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "d-flex flex-row gap-2 justify-content-center mt-10" }
const _hoisted_11 = {
  key: 1,
  for: "upload-file",
  class: "btn btn-primary align-self-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: "avatar-box position-relative d-flex",
                      style: _normalizeStyle({ 'background-image': `url(${_ctx.imageDisplay})` })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "btn align-self-center btn-light",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
                      }, " Remove "),
                      (_ctx.editMode)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            "data-bs-dismiss": "modal",
                            class: "btn btn-primary align-self-center",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                          }, " Save "))
                        : (_openBlock(), _createElementBlock("label", _hoisted_11, [
                            _createTextVNode(" Change "),
                            _createElementVNode("input", {
                              type: "file",
                              id: "upload-file",
                              hidden: "",
                              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileHandle && _ctx.onFileHandle(...args)))
                            }, null, 32)
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}